import React from 'react';
import {
  SetupCardStyled,
  CardBadgeWrapperStyled,
  CardTagStyled,
  CardTitleStyled,
  CardDescStyled,
  CardIconWrapperStyled,
} from '../AdminSetup.styles';

/**
 * SetupCard — the single card used by every Admin Setup section
 * (Organization Management, Organization Role, Module Settings).
 *
 * All props are optional — the card renders only the parts it is given.
 *
 * Props (all optional):
 *  - icon: ReactNode shown in the icon tile
 *  - title: string
 *  - description: single secondary line
 *  - badge: { text, color, icon } shown top-right
 *  - onClick: click handler (navigate or open modal)
 */
const SetupCard = ({ icon = null, title = '', description = '', badge = null, onClick }) => {
  return (
    <SetupCardStyled hoverable size="small" onClick={onClick}>
      {badge?.text && (
        <CardBadgeWrapperStyled>
          <CardTagStyled color={badge.color} icon={badge.icon}>
            {badge.text}
          </CardTagStyled>
        </CardBadgeWrapperStyled>
      )}

      {icon && (
        <CardIconWrapperStyled align="center" justify="center">
          {icon}
        </CardIconWrapperStyled>
      )}

      {title && <CardTitleStyled strong>{title}</CardTitleStyled>}

      {description && <CardDescStyled type="secondary">{description}</CardDescStyled>}
    </SetupCardStyled>
  );
};

export default SetupCard;
